import React from 'react';
import { components } from 'react-select';
import ValidationIcon from '../../icons/ValidationIcon';
export class SingleValue extends React.Component {
  static get propTypes() {
    return {
      ...components.SingleValue.propTypes
    };
  }
  static get defaultProps() {
    return {
      ...components.SingleValue.defaultProps
    };
  }
  getValueWithValidationIcon() {
    const {
      isDisabled,
      valid,
      value,
      visited
    } = this.props.selectProps;
    return /*#__PURE__*/React.createElement(ValidationIcon, {
      valid: valid,
      value: value === null || value === void 0 ? void 0 : value.label,
      disabled: isDisabled,
      visited: visited,
      required: false
    });
  }
  render() {
    const props = {
      ...this.props,
      children: this.getValueWithValidationIcon()
    };
    return /*#__PURE__*/React.createElement(components.SingleValue, props);
  }
}